import { render, staticRenderFns } from "./MarkingAnswerPaperList.vue?vue&type=template&id=062de0e0"
import script from "./MarkingAnswerPaperList.vue?vue&type=script&lang=js"
export * from "./MarkingAnswerPaperList.vue?vue&type=script&lang=js"
import style0 from "./MarkingAnswerPaperList.vue?vue&type=style&index=0&id=062de0e0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports